import React, { useEffect, useState } from 'react';
import { onGeoResolved, GeoInfo } from '../utils/Tracker';
import { buildGreeting, Greeting } from '../utils/LocaleMessage';

const DISMISS_KEY = 'gb4k_greeting_seen_v1';
const SHOW_MS = 9000;

const VisitorGreeting: React.FC = () => {
  const [greeting, setGreeting] = useState<Greeting | null>(null);
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    let alreadySeen = false;
    try {
      alreadySeen = sessionStorage.getItem(DISMISS_KEY) === 'true';
    } catch {}
    if (alreadySeen) return;

    const unsub = onGeoResolved((geo: GeoInfo) => {
      const g = buildGreeting(geo);
      if (!g) return;
      setGreeting(g);
      // Small delay so the boot screen has cleared
      setTimeout(() => setVisible(true), 1500);
      // Auto-close after SHOW_MS
      setTimeout(() => {
        setClosing(true);
        setTimeout(() => setVisible(false), 600);
      }, 1500 + SHOW_MS);
      try { sessionStorage.setItem(DISMISS_KEY, 'true'); } catch {}
    });

    return () => unsub();
  }, []);

  if (!greeting || !visible) return null;

  return (
    <div
      className="fixed top-3 left-3 z-40 max-w-xs pointer-events-auto"
      style={{
        opacity: closing ? 0 : 1,
        transform: closing ? 'translateY(-8px)' : 'translateY(0)',
        transition: 'opacity 0.6s ease, transform 0.6s ease',
      }}
    >
      <div
        className="border border-[var(--terminal-border)] bg-black bg-opacity-70 text-[#5fe979] font-mono p-3 rounded shadow-lg"
        style={{ backdropFilter: 'blur(4px)' }}
      >
        <div className="flex items-center gap-2 mb-1">
          {greeting.emoji && <span className="text-xl">{greeting.emoji}</span>}
          <div className="text-base font-bold text-[#7aff94]">{greeting.primary}</div>
        </div>
        {greeting.subtitle && (
          <div className="text-xs opacity-80">{greeting.subtitle}</div>
        )}
        <button
          className="absolute top-1 right-1 text-xs opacity-40 hover:opacity-100"
          onClick={() => {
            setClosing(true);
            setTimeout(() => setVisible(false), 600);
          }}
          aria-label="Close greeting"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default VisitorGreeting;
